export const paymentsTemplate=`<p>Templates are available for the following payment types:</p>
<p><span style="text-decoration: underline;">Single Debit Multi Credit (SDMC)</span></p>
<ul>
<li>BACS</li>
<li>Faster Payments (FPS)</li>
</ul>
<p><span style="text-decoration: underline;">Single Debit Single Credit (SDSC)</span></p>
<ul>
<li>CHAPS</li>
<li>International Payments</li>
</ul>
<p><span style="text-decoration: underline;">Entitlements</span></p>
<p><strong><em>Manage Templates</em></strong> entitlement is required to be able to create, edit or delete a template.&nbsp;</p>
<p><strong><em>Load Template</em></strong> entitlement is required to load a template to create payment.</p>
<p><strong><em>Approve Template</em></strong> is required to be able to approve new or amended templates via Pending approvals</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/20/1.png' />
<p><span style="text-decoration: underline;">Create Template – general points</span></p>
<p>The template creation process follows the same pattern as creating a payment.&nbsp; Step 1 allows the template to be defined, step 2 is displayed if validation checks have passed and finally step 3 confirms that the template has been created and sent for approval.</p>
<p>For all templates, irrespective of payment type:</p>
<ul>
  <li>The debit account must be selected via the account picker on the left-hand side of the screen.</li>
  <li>A template name is mandatory when creating the template.</li>
  <li>The beneficiary details must be selected from the Beneficiary library – entering free-form beneficiary details is not supported.</li>
  <li>All other fields in the template are optional.</li>
</ul>
<p><span style="text-decoration: underline;">Create BACS / FPS SDMC template</span></p>
<p>The BACS / FPS SDMC template fields include all BACS / FPS SDMC Payment screen fields, aside from Processing date.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/20/2.png' />
<p>The batch booking flag can be used to determine whether the payment is treated as one batch payment, or a single payment once approved.</p>
<p><strong>Batch booking checked:</strong> By checking the batch booking box any payment that is created via this template will show as one Debit posting on payment summary and transaction history.</p>
<p><strong>Batch booking unchecked:</strong> By not checking the batch booking box the individual transactions that are part of the template will be shown on payment summary and transaction history as individual payments.&nbsp;</p>
<p>Note that prior to approval, i.e. when the payment is in a pending approval status, the payment will display as a single line item and only become individual payments post-approval.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/20/3.png' />
<p>Beneficiaries can be added to the template using the Add another beneficiary button.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/20/4.png' />
<p>Beneficiaries must be added from the beneficiary library using the existing search that is present in other payment creation screens.</p>
<p>Note that if a beneficiary is included in a template, and that beneficiary is edited in the beneficiary library, the template is not updated automatically with that change.  You need to edit the template and select the beneficiary from the library to bring the updated beneficiary in to the template.  This change will have to be approved before the template can be loaded with the updated beneficiary details. </p>
<p>It is possible to define specific amounts and a beneficiary reference for any beneficiaries entered, however this is optional.</p>
<p>The beneficiary can be added to the template by selecting the Add button.&nbsp; A maximum of 1000 beneficiaries can be added.</p>
<p>&nbsp;</p>
<p><span style="text-decoration: underline;">Create CHAPS SDSC template</span></p>
<p>The CHAPS SDSC template fields include all CHAPS SDSC Payment screen fields, aside from Processing date. Upon searching for and selecting a domestic beneficiary from the library, the Beneficiary’s Name, Beneficiary type, Sort code and Account number will be populated.</p>
<p>You will see a field labelled LEI within the ‘Debit account details’ under the ‘Bank ID’ field.  Where we have it, we will populate your LEI (Legal Entity Identifier), and the field will not be available to amend.  If this field is empty, you can add in your LEI, which will be a 20-character alphanumeric code, and the last two characters will be numeric.<strong> Please note, letters must be entered in upper case only.</strong> You will need to complete this field from May 2025.</p>
<p>You will also see an LEI field within the ‘Beneficiary details’ section, under the ‘Country’ field.  You will need to complete this field from May 2025 with the beneficiary’s Legal Entity Identifier (LEI).  As mentioned above, this will be a 20-character alphanumeric code where <strong>letters must be entered in upper case only</strong> and the last two characters will be numeric.  Please note any changes made to a beneficiary’s LEI in the CHAPS SDSC template will not be saved to the Beneficiary library.</p>
<p><span style="text-decoration: underline;">Create International SDSC template</span></p>
<p>The International SDSC template fields include all International SDSSC Payment fields aside from: Processing date, Contract ID and Contract Rate. Upon searching for and selecting an international beneficiary from the library, the Beneficiary details and the Beneficiary bank details will be populated, along with Intermediary bank details if these have been defined for the selected beneficiary.</p>
<p><span style="text-decoration: underline;">Template approvals</span></p>
<p>Once the template has been submitted the normal process of validation is followed in the same way as other payments.</p>
<p>Two sections are shown in the Templates summary screen: Pending approval templates and Approved templates.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/20/5.png' />

<div class='row'>
<div class='col-2'>
<p><img src='${process.env.PUBLIC_URL}/images/4/20/6.png' />
</div>
<div class='col-10'>
<p>When a template is pending it is possible to View, Edit or Discard the template.</p>
<p>For approved templates where the user has the Load template entitlement, they will also see the Load option under actions, as well as View, Edit, Delete.</p>

</div>
</div>
<p>To view pending template approvals the Approve template entitlement is required.</p>
<p>All templates that require approval are shown in Approvals &gt; Pending Approvals, in the Templates category.</p>
<p>Once the template has been approved it will be shown in Template Summary screen and available for use.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/20/7.png' />
<p><span style="text-decoration: underline;">Creating a payment via Load Template </span></p>
<div class='row'>
<div class='col-2'>
<p><img src='${process.env.PUBLIC_URL}/images/4/20/6.png' />
</div>
<div class='col-10'>
<p>To create a payment using a template, navigate to Payments > Templates summary and select the three-dot Action menu beside the template where the load option will be available. This requires the Load template entitlement.</p>
<p>Once the template has been loaded all of the details of the template will be populated however, only the beneficiary reference and payment amount can be amended. Details such as the debit account, any associated virtual account, template name and all the beneficiary details loaded from the beneficiary library cannot be amended. This is applicable to all payment types.</p>
</div>
</div>
<p>For BACS / FPS SDMC payments created via a template, it is not possible to add additional beneficiaries to the template via the load process however beneficiaries can be deleted if they are not required on this occasion.&nbsp; Deleting a beneficiary from the loaded template does not delete the beneficiary from the actual saved template.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/20/8.png' />
<p><span style="text-decoration: underline;">Updating Beneficiary reference and Amount – for BACS / FPS SDMC</span></p>
<p>For BACS and FPS SDMC payments created via template, it is possible to use a file upload process to update the beneficiary reference as well as the amounts of each row of the template payment.&nbsp; To load these values the Import beneficiary button must be used.&nbsp; Once pressed the Import payments file window is displayed.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/20/9.png' />
<p><img src='${process.env.PUBLIC_URL}/images/4/20/10.png' />
<p><span style="text-decoration: underline;">Import Beneficiary Format – for BACS / FPS SDMC</span></p>
<p>When using the import process to update the payment amount and beneficiary reference the file must follow the format shown below.&nbsp;</p>
<p>The file format must be .csv and must include rows for all beneficiaries that are present in the template at the point of the update being required.</p>
<table class='table table-bordered'>
<tbody>
<tr>
<td valign="top" width="125" class='table-background'>
<p>Mandatory</p>
</td>
<td valign="top" width="114" class='table-background'>
<p>Mandatory</p>
</td>
<td valign="top" width="116" class='table-background'>
<p>Mandatory</p>
</td>
<td valign="top" width="166" class='table-background'>
<p>Mandatory</p>
</td>
<td valign="top" width="185" class='table-background'>
<p>Mandatory</p>
</td>
</tr>
<tr>
<td valign="top" width="125">
<p><strong>Beneficiary Name</strong></p>
</td>
<td valign="top" width="114">
<p><strong>Beneficiary Sort code</strong></p>
</td>
<td valign="top" width="116">
<p><strong>Beneficiary Account Number</strong></p>
</td>
<td valign="top" width="166">
<p><strong>Beneficiary Reference</strong></p>
</td>
<td valign="top" width="185">
<p><strong>Amount</strong></p>
</td>
</tr>
<tr>
<td valign="top" width="125">
<p>Alphanumeric<br /> Maximum 35 Characters<br /> (A-Z,a-z,0-9), (/ - ? : ( ) . , ' + ) and spaces</p>
</td>
<td valign="top" width="114">
<p>Numeric<br /> Min Length - 6 characters<br /> Max length - 6 characters</p>
</td>
<td valign="top" width="116">
<p>Numeric<br /> Min Length - 8 characters<br /> Max length - 8 characters</p>
</td>
<td valign="top" width="166">
<p>Alphanumeric<br /> Maximum 18 Characters<br /> (A-Z,a-z,0-9), (/ - ? : ( ) . , ' + ) and spaces</p>
</td>
<td valign="top" width="185">
<p>Amount in GBP<br /> The maximum amount that can be supplied is 9999999999.99 - 10 digits before the decimal point and 2 after</p>
</td>
</tr>
</tbody>
</table>
<p>Sample csv file view -</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/20/11.png' />
<p>Once the upload has been validated and confirmed without error the payment will be updated with the new references and amounts for each beneficiary within the payment.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/20/12.png' />
`;


// WEBPACK FOOTER //
// ./src/components/content/payments/20-paymentsTemplate.ts